import { useTranslation } from 'libs/i18n';
import {
  Table,
  TableOnCellClick,
  TablePaginationProps,
  TableSetRowHref,
  TableSortProps,
} from 'libs/ui';

import { OrdersListItem, SortField } from '../../types';

import { useColumns } from './columns';

export interface OrdersTableProps
  extends TableSortProps<SortField>,
    TablePaginationProps {
  orders: OrdersListItem[];
  loading?: boolean;
  brokerTimezoneOffset: number;
  onCellClick?: TableOnCellClick<OrdersListItem>;
  setRowHref?: TableSetRowHref<OrdersListItem>;
}

export const OrdersTable = ({
  orders,
  loading,
  limit,
  rowCount,
  page,
  sort,
  brokerTimezoneOffset,
  onSortChange,
  onCellClick,
  onPaginationChange,
  setRowHref,
}: OrdersTableProps) => {
  const columns = useColumns({ brokerTimezoneOffset });

  const { t } = useTranslation();

  return (
    <Table
      columns={columns}
      limit={limit}
      loading={loading}
      noRowsProps={{
        title: t('common.noRows'),
        text: t('account.orders.noRows.text'),
      }}
      page={page}
      rowCount={rowCount}
      rows={orders}
      setRowHref={setRowHref}
      sort={sort}
      styleVariant="outline"
      onCellClick={onCellClick}
      onPaginationChange={onPaginationChange}
      onSortChange={onSortChange}
    />
  );
};
